import type { ReactNode } from 'react'

/**
 * Renders the child component based on the expression value.
 *
 * @param {any} expression - The expression value used to determine which child component to render.
 * @param {Record<any, any>} children - An object containing the child components.
 */
export const Switch = ({ expression, children }: { expression: any; children: Record<any, ReactNode> }) => {
  return children[expression]
}
